import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { Svg, Path } from '@react-pdf/renderer';

// Icons
const PhoneIcon = () => (
    <Svg viewBox="0 0 24 24" width="12" height="12">
        <Path
            d="M18.427 14.768 17.2 13.542a1.733 1.733 0 0 0-2.45 0l-.613.613a1.732 1.732 0 0 1-2.45 0l-1.838-1.84a1.735 1.735 0 0 1 0-2.452l.612-.613a1.735 1.735 0 0 0 0-2.452L9.237 5.572a1.6 1.6 0 0 0-2.45 0c-3.223 3.2-1.702 6.896 1.519 10.117 3.22 3.221 6.914 4.745 10.12 1.535a1.601 1.601 0 0 0 0-2.456Z"
            stroke="black"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </Svg>
);

const EmailIcon = () => (
    <Svg viewBox="0 0 24 24" width="12" height="12">
        <Path
            d="M4 4h16v16H4z"
            fill="none"
            stroke="black"
            strokeWidth={2}
        />
        <Path
            d="M4 4l8 8 8-8"
            fill="none"
            stroke="black"
            strokeWidth={2}
        />
    </Svg>
);

const LocationIcon = () => (
    <Svg viewBox="0 0 24 24" width="12" height="12">
        <Path
            d="M12 2C8.134 2 5 5.134 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
            stroke="black"
            strokeWidth={2}
            fill="none"
        />
        <Path
            d="M12 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
            fill="black"
        />
    </Svg>
);

const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 10,
        borderBottom: '1 solid #ccc',
        backgroundColor: 'rgb(240,247,236)',
    },
    logo: {
        width: 110,
        height: 32,
    },
    rightColumn: {
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    resortName: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 4,
    },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        marginBottom: 2,
    },
    infoText: {
        fontSize: 10,
    },
});

const PdfHeader = () => (
    <View style={styles.headerContainer}>
        {/* Left - Logo */}
        <Image style={styles.logo} src="/img/heritage_compass.png" />

        {/* Right - Info */}
        <View style={styles.rightColumn}>
            {/* <Text style={styles.resortName}>Jungle Avengers Resort</Text> */}

            <View style={styles.infoRow}>
                <PhoneIcon />
                <Text style={styles.infoText}>+91 84478-45778</Text>
            </View>

            <View style={styles.infoRow}>
                <EmailIcon />
                <Text style={styles.infoText}>info@jungleavengers.com</Text>
            </View>

            <View style={styles.infoRow}>
                <LocationIcon />
                <Text style={styles.infoText}>
                    Jungle Avengers Resort Paramanandpur, Nalitapatia, Kendrapara, Odisha - 754248
                </Text>
            </View>
        </View>
    </View>
);

export default PdfHeader;